<template>
  <div class="container packages">
    <div class="parallax-holder">
      <div class="parallax-img one">
        <img src="../assets/img/exhale.png" alt="" data-scroll-speed="8">
      </div>
      <div class="parallax-img two">
        <img src="../assets/img/courage.png" alt="" data-scroll-speed="6">
      </div>
      <div class="parallax-img three">
        <img src="../assets/img/limit.png" alt="" data-scroll-speed="10">
      </div>
      <div class="parallax-img four">
        <img src="../assets/img/to-do.png" alt="" data-scroll-speed="5">
      </div>
      <div class="parallax-img five">
        <img src="../assets/img/oprah.png" alt="" data-scroll-speed="7">
      </div>
    </div>
    <div class="copy-container top">
      <h1 class="coaching">Coaching Programs</h1>
      <p class="coaching">All progress starts within YOU! Take a deeper look inside yourself by joining one of my Program Offerings: One-on-One Personal Coaching, Virtual Group Mastermind or the Unconditioned Academy.</p>
    </div>

    <div class="carousel-container packages-carousel">
      <vueper-slides autoplay class="no-shadow" :touchable="false">
        <vueper-slide v-for="(slide, i) in slides"
          :key="slide.id"
          :title="slide.title"
          :content="slide.content"></vueper-slide>
      </vueper-slides>
      <!-- <div class="unconditioned">
        <div class="slider-header-one no-carousel">
          <h2 class="unconditioned-mastermind">Unconditioned Mastermind</h2>
        </div>
        <br>
        <h2>A roadmap to creating happy from the inside out</h2>
        <p>Join a Community of Like Minded Individuals on a 12 Week Journey to Optimize your Life & Business.<br>
        - Live Coaching Sessions with Jackie Serviss<br>
        - Access to Unconditioned Program including 6 Core Modules for Personal & Professional Growth <br>
        - Drive Action & Commitment with Accountability Partners<br>
        - Build a Community of Like Minded Individuals Upleveling in Life & Business<br>
        - Mastermind Starting May 15th, 2019</p>
      </div> -->
      

      <div class="signup-form">
        <!-- <button @click="unconditionedMastermind()" class="signup-button">GET STARTED</button> -->
        <router-link to="/coaching"><button class="signup-button">GET STARTED</button></router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import { VueperSlides, VueperSlide } from 'vueperslides'
  import 'vueperslides/dist/vueperslides.min.css'

  export default {
    components: { VueperSlides, VueperSlide },
    mounted: function(){
      $('[data-scroll-speed]').moveIt();
    },
    methods: {
      unconditionedMastermind() {
        window.open("https://jackie-serviss.mykajabi.com/unconditionedmastermind", "_blank"); 
      }
    },
    data: () => ({
      slides: [
        {
          id: 'slide-1',
          title: '<div class="slider-header-one"><span class="pink-header">01.</span>&nbsp;&nbsp;One-on-One Personal Coaching</div>',
          content: '<div class="pkg-one-img"></div><br><p>If you are looking for an authentic connection, a highly structured program, a clear action plan and an accountability partner then individual coaching is the right fit for you. This program focuses on self-discovery, breaking through conditioned thought patterns and creating a holistic plan to optimize all areas of your life.</p>'
        },
        {
          id: 'slide-2',
          title: '<div class="slider-header-two"><span class="pink-header">02.</span>&nbsp;&nbsp;Virtual Group Mastermind</div>',
          content: '<div class="pkg-two-img"></div><br><p>You’ll be joined by a group of like-minded individuals on a twelve-week instructor-led journey rooted in the signature Unconditioned offering. The program includes live webinars, guest speakers, workbooks & tools, accountability systems and REAL conversations.</p>'
        },
        {
          id: 'slide-3',
          title: '<div class="slider-header-three"><span class="pink-header">03.</span>&nbsp;&nbsp;Unconditioned Academy</div>',
          content: '<div class="pkg-three-img"></div><br><p>A self guided online experience that moves you through a six-step process to discovering your truth. Each module is broken down to provide clear guidance & direction accompanied by a downloadable workbook to document your progress.</p>'
        }
      ]
    })
  };

  $.fn.moveIt = function(){
    var $window = $(window);
    var instances = [];
    
    $(this).each(function(){
      instances.push(new moveItItem($(this)));
    });


    
    window.addEventListener('scroll', function(){
      var scrollTop = $window.scrollTop();
      instances.forEach(function(inst){
        inst.update(scrollTop);
      });
    }, {passive: true});
  }

  var moveItItem = function(el){
    this.el = $(el);
    this.speed = parseInt(this.el.attr('data-scroll-speed'));
  };

  moveItItem.prototype.update = function(scrollTop){
    this.el.css('transform', 'translateY(' + -(scrollTop / this.speed) + 'px)');
  };

  // Initialization
  $(function(){
    $('[data-scroll-speed]').moveIt();
  });

</script>

<style>

  h1.coaching {
    font-family: adobe-caslon-pro, serif;
    font-weight: 700;
    font-style: italic;
    color: #575757;
  }

  p.coaching {
    font-family: brandon-grotesque, sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 20px;
  }

  
  .packages {
    background-color: #fff;
    width: 75%;
    margin: 0 auto;
    padding: 250px 0 0px;
  }
  .packages img { margin: 0 auto; }

  .carousel-container {
    margin-top: 60px;
  }
  .carousel-container.packages-carousel {
    margin-bottom: 100px;
    width: 100%;
  }

  .carousel-container.packages-carousel .vueperslides__parallax-wrapper {
    height: 540px;
    padding-bottom: 0 !important;
  }

  .carousel-container.packages-carousel .vueperslides__arrows { display: block; }
  .testing { 
    color: #afb0d6;
    font-size: 26px;
    font-family: 'Times New Roman', serif;
    font-style: italic;

  }

  .carousel-container.packages-carousel .vueperslide {
    background-color: #efefef;
    height: 540px;
  }

  .carousel-container.packages-carousel .vueperslide__content p {
    color: #2e3192;
    /*padding-bottom: 20px;*/
    width: 700px;
    margin: 0 auto;
  }

  .carousel-container.packages-carousel .vueperslides__bullets button { margin: 0px 5px 20px; }
  .carousel-container.packages-carousel .vueperslides__bullets { bottom: 40px !important; }

  .carousel-container.packages-carousel .vueperslides__bullet {
    border-radius: 0px;
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    margin: 1.5em .6em;
    padding: 0;
    -webkit-transition: .4s ease-in-out;
    -o-transition: .4s ease-in-out;
    transition: .4s ease-in-out;
    width: 12px; 
    height: 6.93px;
    background-color: #afb0d6;
    margin: 3.46px 0;
    margin-right: 5px;
    position: relative;
  }
  .carousel-container.packages-carousel .vueperslides__bullet--active { 
    border-width: 6px; 
    background-color: #2e3192;
    -webkit-transition: .4s ease-in-out;
    -o-transition: .4s ease-in-out;
    transition: .4s ease-in-out;
  }

  .carousel-container.packages-carousel .vueperslides__bullet:before,
  .carousel-container.packages-carousel .vueperslides__bullet:after {
    content: "";
    position: absolute;
    width: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    -webkit-transition: .4s ease-in-out;
    -o-transition: .4s ease-in-out;
    transition: .4s ease-in-out;
  }

  .carousel-container.packages-carousel .vueperslides__bullet:before {
    bottom: 100%;
    border-bottom: 3.46px solid #afb0d6;
  }

  .carousel-container.packages-carousel .vueperslides__bullet:after {
    top: 100%;
    width: 0;
    border-top: 3.46px solid #afb0d6;
  }

  .carousel-container.packages-carousel .vueperslides__bullet--active:before,
  .carousel-container.packages-carousel .vueperslides__bullet--active:after {
    content: "";
    position: absolute;
    width: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    -webkit-transition: .4s ease-in-out;
    -o-transition: .4s ease-in-out;
    transition: .4s ease-in-out;
  }

  .carousel-container.packages-carousel .vueperslides__bullet--active:before {
    bottom: 100%;
    border-bottom: 3.46px solid #2e3192;
  }

  .carousel-container.packages-carousel .vueperslides__bullet--active:after {
    top: 100%;
    width: 0;
    border-top: 3.46px solid #2e3192;
  }

  .vueperslide__content-wrapper { height: 100%; }

  .vueperslide__content p { font-size: 20px; }



  .unconditioned {
    background-color: #efefef;
    
  }
  .unconditioned h2 {
    font-size: 30px;
    font-family: adobe-caslon-pro, serif;

  }
  .unconditioned p {
    padding: 0 10px 30px 10px;
    line-height: 35px;
    font-family: 20px;
  }
  /*.slider-header-one.no-carousel{
    background-image: url("../assets/img/virtual-mastermind.png");
    background-size: 70%;
    background-repeat: no-repeat;
    background-position: center;
    height: 100px;
    position: relative;
    top: -116px;
    background-color: #2e3094;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }*/
  h2.unconditioned-mastermind {
    font-family: 'lust';
    color: #fff;
    font-size: 45px;
  }
  .slider-header-one{
    /*background-image: url("../assets/img/personal-coaching.png");*/
    /*background-size: 700px;*/
    background-repeat: no-repeat;
    background-position: center;
    height: 100px;
    position: relative;
    /*top: -116px;*/
    background-color: #2e3094;
    width: 100vw;
    margin-bottom: 40px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-family: 'lust';
    color: #fff;
    font-size: 40px;
  }
  .slider-header-two{
    /*background-image: url("../assets/img/virtual-mastermind.png");*/
    /*background-size: 650px;*/
    background-repeat: no-repeat;
    background-position: center;
    height: 100px;
    position: relative;
    /*top: -116px;*/
    background-color: #2e3094;
    width: 100vw;
    margin-bottom: 40px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-family: 'lust';
    color: #fff;
    font-size: 40px;
  }
  .slider-header-three{
    /*background-image: url("../assets/img/unconditioned-academy.png");*/
    /*background-size: 600px;*/
    background-repeat: no-repeat;
    background-position: center;
    height: 100px;
    position: relative;
    /*top: -116px;*/
    background-color: #2e3094;
    width: 100vw;
    margin-bottom: 40px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-family: 'lust';
    color: #fff;
    font-size: 40px;
  }
  span.pink-header { color: #afb0d6; }
    
  .pkg-one-img {
    background-image: url("../assets/img/package1.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    height: 100px;
    position: relative;
    /*top: -40px; */
  }
  .pkg-two-img {
    background-image: url("../assets/img/package2.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    height: 100px;
    position: relative;
    /*top: -40px; */
  }
  .slider-header-one.no-carousel .pkg-two-img.no-carousel {
    height: 200px;
  }
  .pkg-three-img {
    background-image: url("../assets/img/package3.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    height: 100px;
    position: relative;
    /*top: -40px; */
  }

  .copy-container.bottom {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    /*padding: 0 30px;*/
  }
  .img-left {
    width: 400px;
    height: 525px;
    background-image: url(../assets/img/mini-about.jpg);
  }
  .copy-right-side {
    width: 50%;
    text-align: left;
    margin-left: 40px;
  }

  .copy-container.video {
    margin-top: 60px;
    height: 100%;
  }


  .vueperslides__arrow {
    background-color: #afb0d6;
    height: 120px;
    top: 260px;
    opacity: 1;
  }

  .vueperslides__arrow svg path { fill: #fff; }

  .vueperslides__arrow:hover { background-color: #5c5eb4; }

  .vueperslides__arrow.vueperslides__arrow--prev { left: -25px; }
  .vueperslides__arrow.vueperslides__arrow--next { right: -25px; }

  .signup-button {
    border: none;
    background-color: #2e3192;
    color: #fff;
    text-transform: uppercase;
    font-size: 20px;
    padding: 17px 20px 17px 20px;
    border-radius: 5px;
    top: 40px;
    position: relative;
    transition: all 0.15s linear;
  }
  .signup-button:hover {
    background-color: #5c5eb4;
  }

  .signup-button:focus {
    outline: none;
  }

  @media (max-width: 1130px) and (min-width: 975px) {
    .vueperslide__content-wrapper:not(.vueperslide__content-wrapper--outside-top):not(.vueperslide__content-wrapper--outside-bottom) {
      top: 35% !important;
    }

    .copy-right-side h1 { margin: 0; }

    .copy-right-side p { margin-top: 0; }
  }

  @media (max-width: 775px) {
    .packages { padding: 100px 0; }
    .parallax-holder img { width: 310% !important; }

    .parallax-img.five { right: 30px !important; }
    .parallax-img.three {
      position: relative;
      left: -40px;
      top: 20px;
    }
    .parallax-img.four {
      position: relative;
      top: 340px;
      left: -150px;
    }

    .parallax-img.four img { width: 90px !important; }

    .copy-container.top { text-align: left; }

    .copy-container.bottom { flex-direction: column; }
    .img-left { width: 100%; }

    .copy-right-side { 
      width: 100%;
      margin: 0;
    }

    .slider-header-one {
      /*top: -42px;*/
      /*background-size: 90%;*/
      /*background-position-x: center;*/
      width: 100%;
      font-size: 20px;
      height: 150px;
    }
    .slider-header-two {
      /*top: -76px;*/
      /*background-size: 90%;*/
      /*background-position-x: center;*/
      width: 100%;
      font-size: 20px;
      height: 150px;
    }
    .slider-header-three {
      /*top: -87px;*/
      /*background-size: 90%;*/
      /*background-position-x: center;*/
      width: 100%;
      font-size: 20px;
      height: 150px;
    }

    .pink-header { display: none; }

    .pkg-one-img,
    .pkg-two-img,
    .pkg-three-img { top: -50px; }

    .carousel-container.packages-carousel .vueperslides__bullets { display: none; }


    .carousel-container.packages-carousel .vueperslides__parallax-wrapper,
    .carousel-container.packages-carousel .vueperslide { height: 720px; }



    .carousel-container.packages-carousel .vueperslide__content p {
      width: 200px;
      margin-top: -60px;
    }

    .packages .vueperslides__arrow {
      width: 40px !important;
      padding: 0;
    }

    .unconditioned h2 {
      font-size: 25px;
      padding: 0 10px;
    }

    h2.unconditioned-mastermind {
      font-family: 'lust';
      color: #fff;
      font-size: 25px;
    }

    .packages .signup-button { top: 40px; }
    .carousel-container.packages-carousel { margin-bottom: 40px; }
  }


  /*PARALLAX*/
  .parallax-holder {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    -ms-flex-align: center;
    height: 40vh;
    width: 70%;
    margin: 0 auto;
    position: relative;
    top: 300px;
    left: 0px;
    /*perspective: 1px;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;*/
  }

  .parallax-img.one {
    position: relative;
    left: -50px;
  }
  .parallax-img.five {
    position: relative;
    right: 70px;
    top: 50px;
  }

  .parallax-holder .parallax-img {
    width: 20%;

  }

  .copy-container.top {
    margin-top: 100px;
  }
  



</style>


// WEBPACK FOOTER //
// src/components/Packages.vue